import { Input } from "components";
import { useEffect, useState } from "react";
import { ModelPropertyBase } from "generated/openApi";
import { ValidationErrors } from "@compass/core";

export type PhoneNumberInputProps = {
  label?: string | undefined;
  errors?: ValidationErrors | string[];
  value: string | undefined;
  updatePhoneNumber: (value: string) => void;
  required?: boolean;
  isDisabled?: boolean;
  modelProperty?: ModelPropertyBase | undefined;
};

export type FormattedPhoneNumber = {
  sanitizedPhoneNumber: string;
  formattedPhoneNumber: string;
}

export const PhoneNumberInput = ({
  label,
  errors,
  value,
  updatePhoneNumber,
  required,
  isDisabled,
  modelProperty
}: PhoneNumberInputProps) => {
  
  const countryCode = "+1";
  const [formattedPhoneNumber, setFormattedPhoneNumber] = useState<FormattedPhoneNumber>({ sanitizedPhoneNumber: "", formattedPhoneNumber: "" });

  useEffect(() => {
    formatPhoneNumber(value);
  }, [value]);

  useEffect(() => {
    updatePhoneNumber(formattedPhoneNumber.sanitizedPhoneNumber);
  }, [formattedPhoneNumber]);

  
    const formatPhoneNumber = (phoneNumber: string | undefined | null) => {
    if (!phoneNumber) return null;

    // Remove all non-numeric characters
    let sanitizedPhoneNumber = phoneNumber.replace(/\D/g, '');
    if (sanitizedPhoneNumber.startsWith("1")) {
      sanitizedPhoneNumber = sanitizedPhoneNumber.slice(1, sanitizedPhoneNumber.length);
    }

    if (sanitizedPhoneNumber.length > 3 && sanitizedPhoneNumber.length < 7) {
      const areaCode = sanitizedPhoneNumber.slice(0, 3);
      const numberPart1 = sanitizedPhoneNumber.slice(3, 6);

      const formatPhoneNumber = `${countryCode} ${areaCode}-${numberPart1}`;
      const result: FormattedPhoneNumber = {
        formattedPhoneNumber: formatPhoneNumber,
        sanitizedPhoneNumber: "1" + sanitizedPhoneNumber
      };

      setFormattedPhoneNumber(result);
      return;
    }

    if (sanitizedPhoneNumber.length >= 7 && sanitizedPhoneNumber.length <= 10) {
      const areaCode = sanitizedPhoneNumber.slice(0, 3);
      const numberPart1 = sanitizedPhoneNumber.slice(3, 6);
      const numberPart2 = sanitizedPhoneNumber.slice(6);

      const formatPhoneNumber = `${countryCode} ${areaCode}-${numberPart1}-${numberPart2}`;
      const result: FormattedPhoneNumber = {
        formattedPhoneNumber: formatPhoneNumber,
        sanitizedPhoneNumber: "1" + sanitizedPhoneNumber
      };
      setFormattedPhoneNumber(result);
      return;
    }

    if (sanitizedPhoneNumber.length == 11) {
      const areaCode = sanitizedPhoneNumber.slice(1, 4);
      const numberPart1 = sanitizedPhoneNumber.slice(4, 7);
      const numberPart2 = sanitizedPhoneNumber.slice(7);

      const formatPhoneNumber = `${countryCode} ${areaCode}-${numberPart1}-${numberPart2}`;
      const result: FormattedPhoneNumber = {
        formattedPhoneNumber: formatPhoneNumber,
        sanitizedPhoneNumber: "1" + sanitizedPhoneNumber
      };
      setFormattedPhoneNumber(result);
      return;
    }

    const formatPhoneNumber = `${countryCode} ${sanitizedPhoneNumber}`;
    const result: FormattedPhoneNumber = {
      formattedPhoneNumber: formatPhoneNumber,
      sanitizedPhoneNumber: "1" + sanitizedPhoneNumber
    };
    setFormattedPhoneNumber(result);
    return;
  };

  return (
    <>
      <Input
        label={modelProperty?.displayName || label}
        errors={errors}
        value={formattedPhoneNumber.formattedPhoneNumber}
        required={modelProperty?.required || required}
        disabled={isDisabled}
        type="tel"
        maxLength={15}
        onChange={(e) => {
          formatPhoneNumber(e.target.value);
        }}
      />
    </>
  );
};
